import * as React from 'react';
import clsx from 'clsx';

import { generateAriaProps } from './inputHelpers';

export interface ComponentRadiobuttonInputProps {
  checked: boolean;
  className?: string;
  disabled?: boolean;
  hasError?: boolean;
  error?: string | object;
  hint?: string;
  component: React.ReactNode;
  label: string;
  name?: string;
  id?: string;
  onBlur?(event: React.FocusEvent<HTMLInputElement>): void;
  onChange?(event: React.ChangeEvent<HTMLInputElement>): void;
  onFocus?(event: React.FocusEvent<HTMLInputElement>): void;
}

export const ComponentRadiobutton = React.memo(
  ({
    checked,
    className,
    disabled,
    error,
    hasError,
    hint,
    component,
    label,
    name,
    id,
    ...restProps
  }: ComponentRadiobuttonInputProps) => {
    const componentClassName = clsx('RadioButton', className, {
      'is-checked': checked,
      'is-disabled': disabled,
    });

    const ariaProps = generateAriaProps({
      hasError,
      label,
      name,
      hint,
    });

    return (
      <>
        <label htmlFor={id} className={componentClassName}>
          <input
            className="Input RadioButton-input"
            {...restProps}
            {...ariaProps}
            id={id}
            name={name}
            value={id}
            type="radio"
            checked={checked}
            aria-checked={checked}
          />
          <div className="RadioButton-indicator" role="radio" aria-checked={checked} aria-hidden>
            {component}
          </div>
        </label>
        {hint && (
          <div className="Hints">
            <div className="Hint">{hint}</div>
          </div>
        )}
      </>
    );
  }
);
